import { isTelegramMiniApp } from "./telegram.ts";

/**
 * PWA / standalone detection for native-like behavior
 * (persist intro/role across lock/unlock, etc.)
 */
export function isPWAStandalone(): boolean {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    (window.navigator as { standalone?: boolean }).standalone === true
  );
}

/**
 * Use persistent storage (localStorage) for intro/role when in PWA or Mini App,
 * so lock/unlock doesn't re-show intro or role choice.
 */
export function shouldPersistSession(): boolean {
  return isPWAStandalone() || isTelegramMiniApp();
}
